<template>
  <a-modal
    title="修改用户头像"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :width="800"
    @cancel="cancelHandel">
    <a-row type="flex" align="middle">
      <a-col :span="12">
        <vue-cropper
          ref="cropper"
          :img="options.img"
          :info="true"
          :autoCrop="options.autoCrop"
          :autoCropWidth="options.autoCropWidth"
          :autoCropHeight="options.autoCropHeight"
          :fixedBox="options.fixedBox"
          @realTime="realTime"
          style="width: 100%;height: 350px">
        </vue-cropper>
        <div style="display: flex;align-items: center;justify-content: center;margin-top: 12px">
          <a-icon type="bulb" theme="twoTone"/>
          <span style="margin-left: 4px;color: #3f51b5;font-weight: bold;">鼠标滚轮可以缩放图片大小</span>
        </div>
      </a-col>
      <a-col :span="12">
        <div class="avatar-upload-preview">
          <img :src="previews.url" :style="previews.img"/>
        </div>
      </a-col>
    </a-row>
    <input ref="file" type="file" accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event, 1)" style="display:none">

    <template slot="footer">
      <a-button key="delete" type="danger" @click="$refs.file.click()">上传图片</a-button>
      <a-button key="back" @click="cancelHandel">取消</a-button>
      <a-button key="submit" type="primary" :loading="confirmLoading" @click="okHandel">确定</a-button>
    </template>
  </a-modal>
</template>
<script>
import qs from 'qs'
import { VueCropper } from 'vue-cropper'

export default {
  components: {
    VueCropper
  },
  data () {
    return {
      visible: false,
      id: null,
      confirmLoading: false,
      options: {
        img: '',
        autoCrop: true,
        autoCropWidth: 90,
        autoCropHeight: 110,
        fixedBox: true
      },
      previews: {}
    }
  },
  methods: {
    edit (id) {
      this.visible = true
      this.id = id
      /* 获取原始头像 */
    },
    close () {
      this.id = null
      this.visible = false
    },
    cancelHandel () {
      this.close()
    },
    okHandel () {
      this.uploadImgRemote()
    },
    realTime (data) {
      this.previews = data
    },
    uploadImg (e) {
      // 上传图片
      // this.option.img
      var file = e.target.files[0]
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
        return false
      }
      var reader = new FileReader()
      reader.onload = e => {
        let data
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }

        this.options.img = data
      }
      // 转化为blob
      reader.readAsArrayBuffer(file)
    },
    uploadImgRemote () {
      const that = this
      that.confirmLoading = true
      that.$refs.cropper.getCropData(data => {
        that.$http.post('/api/1/org/edit_user_avatar_base64.json', qs.stringify({ userId: this.id, avatar: data })).then(function (resp) {
          that.$message.success('上传头像成功')
          that.confirmLoading = false
          that.onReloadPage()
        })
      })
    },
    onReloadPage () {
      this.$emit('success')
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>

  .avatar-upload-preview {
    position: absolute;
    top: 50%;
    left: 30%;
    transform: translate(50%, -50%);
    width: 90px;
    height: 110px;
    /*border-radius: 50%;*/
    box-shadow: 0 0 4px #ccc;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }
</style>
